import { type LocalDate, logError } from '@zg-rentals/rental-manager-env';

export function isValidDateString(dateString: string, invoiceNumber?: string) {
  const date = new Date(dateString);
  const isValid = !isNaN(date.getTime());
  if (!isValid) {
    logError({
      error: new Error(`Invalid date string for invoice ${invoiceNumber}: ${dateString}`),
      errorType: 'InvalidDateString',
      context: {
        invoiceNumber,
        dateString,
      },
    });
  }
  return isValid;
}

export function localDateToDate(date: LocalDate) {
  return new Date(date.year, date.month - 1, date.day);
}
